const filterOptions = document.querySelectorAll(".filter-option");
filterOptions.forEach(function(element){
    element.addEventListener('click', function(){
        this.closest('.filter-option-container').classList.toggle('active');
        // const dropdown = this.querySelector('.filter-option-dropdown');
        // dropdown.classList.remove('h-0');
        // console.log(dropdown);
    });
});